export const round = (a, precision = 3) => +a.toFixed(precision);